import queryString from 'query-string'
import xhr from './xhr'
const api = {}

/****************************************
  Contact
*****************************************/

api.sendGeneralContactForm = (name, email, message) => {
  return xhr.post('/contact/general', { name, email, message })
}

/****************************************
  Blog
*****************************************/

api.getBlogClaps = slug => {
  const query = queryString.stringify({ slug })
  return xhr.get(`/blog-claps?${query}`)
}

api.addBlogClaps = (slug, claps) => {
  return xhr.post('/blog-claps', { slug, claps })
}

/****************************************
 Workshops
 *****************************************/

api.getWorkshop = (workshopId, data = {}) => {
  const query = queryString.stringify(data)
  return xhr.get(`/workshops/${workshopId}?${query}`)
}

api.addEmailToWaitlist = () => {
  console.log('NEED TO PROGRAM')
}

api.createWorkshopCheckoutSession = (workshopId, tickets, attendees) => {
  return xhr.post(`/workshops/createCheckoutSession`, { workshopId, tickets, attendees })
}

export default api
